import React from "react";
import Name from "../../../../components/forms/userForms/name/name";
import BirthDay from "../../../../components/forms/userForms/userBirthDay/birthDay";

export default function FirstPageForm() {
  
  return (
    <>
    <Name />
    <BirthDay />
  </>
  );
}
